import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

const CAMPOS = [
  { name: "quantidadeAulas", label: "Quantidade Aulas" },
  { name: "quantidadeFaltas", label: "Quantidade Faltas" },
  { name: "ausenciaCompensada", label: "Ausência Compensada" },
  { name: "frequencia", label: "Frequência (%)" },
];

const toInput = (value) => (value === null || value === undefined ? "" : String(value));

/** Edição completa (admin) de um registro de frequência do aluno. */
export default function AusenciaCompensadaForm({
  alunoFrequencia,
  onClose,
  onSave,
  isSaving,
  onCreateUpdateAlunoTurma,
}) {
  const [valores, setValores] = useState({});

  useEffect(() => {
    if (!alunoFrequencia) return;
    setValores(Object.fromEntries(CAMPOS.map(({ name }) => [name, toInput(alunoFrequencia[name])])));
  }, [alunoFrequencia]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValores((prevState) => ({ ...prevState, [name]: value.replace(/[^\d.,]/g, "").replace(",", ".") }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const persist = { ...alunoFrequencia };
    CAMPOS.forEach(({ name }) => {
      persist[name] = valores[name] === "" ? null : Number(valores[name]);
    });
    onSave(persist);
  };

  return (
    <Dialog open={Boolean(alunoFrequencia)} onClose={onClose} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <DialogTitle>
          Editar Frequência
          <Typography variant="body2" color="text.secondary">
            {alunoFrequencia?.alunoTurma?.aluno?.nome}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} pt={1}>
            {CAMPOS.map(({ name, label }) => (
              <Grid key={name} size={{ xs: 6 }}>
                <TextField
                  size="small"
                  fullWidth
                  label={label}
                  name={name}
                  value={valores[name] ?? ""}
                  onChange={handleChange}
                  slotProps={{ htmlInput: { inputMode: "decimal", maxLength: 6 } }}
                />
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          {onCreateUpdateAlunoTurma && (
            <Button color="inherit" onClick={() => onCreateUpdateAlunoTurma(alunoFrequencia)} sx={{ mr: "auto" }}>
              Criar/Atualizar por Aluno Turma
            </Button>
          )}
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained" disabled={isSaving}>
            Salvar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
